import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-oro bg-ciencia-light" data-id="element-107" data-mp="8mdmfcb6rh3m">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-108" data-mp="dfyg4s5qxox0">
        <p className="inline-block rounded-md bg-naranja-dark px-2 py-0.5 font-sub text-sm font-extrabold leading-tight text-white" data-id="element-109" data-mp="icorj26lvwc3">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[1.5rem] uppercase leading-[1.1] text-noche sm:text-4xl" data-id="element-110" data-mp="refwu5x8i15f">
          Empezá hoy con todo el material organizado y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-noche bg-white text-noche" data-id="element-111" data-mp="2y4cr75d082yl">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block bg-white" data-id="element-112" data-mp="12o1x37kq5aa5">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos y 5 bonos incluidos`} className="block w-full" data-id="element-113" data-mp="xuyygl13ban3" />
          </a>
          <div className="p-3" data-id="element-114" data-mp="oxyfitwsi4r1">
            <p className="font-sub text-sm font-extrabold uppercase leading-tight text-noche" data-id="element-115" data-mp="1lme2qjcfg20z">
              {PRODUCT_NAME}
            </p>
            <p className="mt-1 inline-block rounded-md bg-oro px-2 py-0.5 font-display text-2xl uppercase leading-tight text-noche" data-id="element-116" data-mp="1gocnyam1aovb">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-xs font-semibold text-noche-dark/80 sm:text-sm" data-id="element-117" data-mp="17n4se0awk24x">
              🎁 Bonos valorados en{' '}
              <span className="line-through decoration-red-600 decoration-2" data-id="element-118" data-mp="17as10ae56jd">{BONUS_TOTAL}</span>
            </p>

            <p className="mt-2 inline-block rounded-full bg-naranja-dark px-3 py-0.5 font-sub text-xs font-extrabold uppercase text-white" data-id="element-119" data-mp="3sbiys077ts06">
              🔥 Oferta especial
            </p>
            <p className="mx-auto mt-1 w-fit rounded-xl border-2 border-noche bg-oro px-3 py-1 font-display text-5xl leading-none text-noche sm:text-6xl" data-id="element-120" data-mp="2n6g0a1pmv4w">
              <span className="text-2xl sm:text-3xl" data-id="element-121" data-mp="3oumxh20xi3b2">Hoy:</span> {PRICE}
            </p>
            <p className="mt-1.5 text-xs font-semibold text-noche-dark/80" data-id="element-122" data-mp="3b3i3afgby384">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-123" data-mp="3fvt2th75rn05">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-noche-dark/80" data-id="element-124" data-mp="363vpo4wlakys">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}